// Seleção "Quero estudar para" — persiste banca/concurso escolhidos e é
// reutilizada como filtro inicial em Questões, Simulados, Incidência, Mapas e Plano.
const KEY = "vc_estudo";

export function getEstudo() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { banca: "Todas", concurso: "Todas" };
    const v = JSON.parse(raw);
    return { banca: v.banca || "Todas", concurso: v.concurso || "Todas", label: v.label };
  } catch {
    return { banca: "Todas", concurso: "Todas" };
  }
}

export function setEstudo(sel) {
  localStorage.setItem(KEY, JSON.stringify(sel));
  window.dispatchEvent(new Event("vc-estudo"));
}

export function clearEstudo() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("vc-estudo"));
}
